module.exports = __webpack_public_path__ + "static/media/Honey.176b9832.png";